// On-screen IAST keyboard. Produces the correct Sanskrit diacritics directly so
// the learner never needs an ASCII fallback. Touch-first: ≥44px keys, wraps and
// scrolls responsively, compact on phones. See COURSES-SPEC §3.

const BASE_LATIN = 'a b c d e f g h i j k l m n o p q r s t u v w x y z'.split(' ');

// The IAST diacritic set as their own keys (vowels with macron/ring, anusvāra,
// visarga, the retroflex/palatal/nasal consonants, and the aspirated retroflexes).
const DIACRITICS = [
  'ā', 'ī', 'ū', 'ṛ', 'ṝ', 'ḷ', 'ḹ', 'ē', 'ō',
  'ṃ', 'ḥ', 'ṅ', 'ñ', 'ṭ', 'ṭh', 'ḍ', 'ḍh', 'ṇ', 'ś', 'ṣ', 'ḻ',
];

export function IastKeyboard({
  onInsert,
  onBackspace,
}: {
  onInsert: (s: string) => void;
  onBackspace: () => void;
}) {
  const keyClass =
    'min-w-[44px] min-h-[44px] px-2 grid place-items-center rounded-md border border-[var(--color-rule)] ' +
    'bg-[var(--color-vellum)] text-[var(--color-ink)] text-[1.05rem] leading-none ' +
    'hover:border-[var(--color-violet)] hover:bg-[var(--color-vellum-dim)] active:bg-[var(--color-vellum-dim)] ' +
    'transition-colors select-none';

  return (
    <div className="flex flex-col gap-2">
      {/* Diacritics first — the keys that matter for IAST. */}
      <div className="flex flex-wrap gap-1.5">
        {DIACRITICS.map((ch) => (
          <button key={ch} type="button" className={keyClass} onClick={() => onInsert(ch)}>
            {ch}
          </button>
        ))}
      </div>

      <div className="flex flex-wrap gap-1.5">
        {BASE_LATIN.map((ch) => (
          <button key={ch} type="button" className={keyClass} onClick={() => onInsert(ch)}>
            {ch}
          </button>
        ))}
        <button
          type="button"
          className={keyClass + ' min-w-[56px] font-grotesk text-[0.85rem]'}
          onClick={onBackspace}
          aria-label="Backspace"
        >
          ⌫
        </button>
      </div>
    </div>
  );
}
